/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { version } from "../../package.json";
import { containerURL } from "../data/Download.json";

import CLOSE from "../assets/image/btn_close@2x.png";
import MAC from "../assets/image/ico_apple@2x.png";
import { downloadFile } from "../helpers";

const flexStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
};

const bgStyle = {
  ...flexStyle,
  width: "100vw",
  height: "100vh",
  zIndex: "2040",
  background: `rgba(0,0,0,0.4)`,
  position: "fixed",
  top: "0",
  left: "0",
};

const modalStyle = {
  ...flexStyle,
  width: "400px",
  height: "280px",
  zIndex: "2050",
  background: "#fff",
  boxSizing: "border-box",
  padding: "20px",
};

const closeWrapStyle = {
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
};

const closeIconStyle = {
  width: "24px",
  height: "24px",
  cursor: "pointer",
};

const contentStyle = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
};

const iconWrapStyle = {
  width: "96px",
  height: "96px",
  background: "#ddd",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  marginBottom: "10px",
};

const imgStyle = {
  width: "64px",
  height: "64px",
};

const btnWrapStyle = {
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "20px",
};

const btnStyle = {
  borderRadius: "5px",
  border: "none",
  padding: "10px",
};

const btnSubmitStyle = {
  ...btnStyle,
  background: "rgb(15, 189, 133)",
  color: "#fff",
};

export const MacVersionsModal = ({ handleClose }) => {
  const intelClick = () =>
    downloadFile({ url: `${containerURL}/darwin/CoLine-${version}-mac.zip` });
  const armClick = () =>
    downloadFile({
      url: `${containerURL}/darwin/CoLine-${version}-arm64-mac.zip`,
    });

  return (
    <div style={bgStyle}>
      <div style={modalStyle}>
        <div style={closeWrapStyle}>
          <img
            src={CLOSE}
            style={closeIconStyle}
            draggable={false}
            onClick={handleClose}
          />
        </div>
        <div style={contentStyle}>
          <div style={iconWrapStyle}>
            <img style={imgStyle} src={MAC} draggable={false} />
          </div>
          <h2>
            <b>macOS版本</b>
          </h2>
          <div style={btnWrapStyle}>
            <button style={btnSubmitStyle} onClick={intelClick}>
              下載macOS Intel版
            </button>
            <button style={btnStyle} onClick={armClick}>
              下載macOS Silicon版
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
